@if (isOpen()) {
  <div
    class="modal-overlay"
    [class.modal-overlay--review]="step() === 4"
    role="dialog"
    aria-modal="true"
  >
    <div class="modal-container">
      @if (step() !== 5 && step() !== 1) {
        <div class="modal-header">
          <div class="modal-header__text">
            <h2 class="modal-title">{{ modalTitle() }}</h2>
            @if (modalSubtitle()) {
              <p class="modal-subtitle">{{ modalSubtitle() }}</p>
            }
          </div>
          <button type="button" class="modal-close" (click)="closeModal()" aria-label="Close">
            <span class="modal-close-icon">×</span>
          </button>
        </div>
      }
      @if (step() === 1) {
        <button
          type="button"
          class="modal-close modal-close--floating"
          (click)="closeModal()"
          aria-label="Close"
        >
          <span class="modal-close-icon">×</span>
        </button>
      }

      <div
        class="modal-body"
        [class.modal-body--centered]="step() === 0"
        [class.modal-body--gemini]="step() === 1"
        [class.modal-body--wide]="step() === 4"
        [class.modal-body--review]="step() === 4"
      >
        @if (step() === 0) {
          <app-step-choice />
        }
        @if (step() === 1) {
          <app-step-business-info />
        }
        @if (step() === 3) {
          <app-step-generating />
        }
        @if (step() === 4) {
          <app-step-review />
        }
        @if (step() === 5) {
          <app-step-success />
        }
      </div>
    </div>
  </div>
}
